import { CoreUserRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class CoreUserService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new CoreUserRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	findByUserName(username, options) {
		var url = this.routeService.findByUserName(username, options);
		return this.apiClient.get(url, findParams(username));
	}

	remove(id) {
		var url = this.routeService.delete(id);
		return this.apiClient.delete(url + id);
	}
}

export default CoreUserService;



// WEBPACK FOOTER //
// ./src/common/data/services/CoreUserService.js